/**
 * Quick Add to Cart functionality
 * Material Design implementation for Shopify
 */

(function() {
  'use strict';

  console.log('Quick-add-to-cart.js loaded');

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    console.log('Document still loading, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    console.log('Document already ready, initializing now');
    init();
  }

  function init() {
    console.log('Quick-add init() called');
    
    // Check if containers exist
    const containers = document.querySelectorAll('.quick-add-container');
    console.log('Found', containers.length, 'quick-add-container elements');
    
    // Check if buttons exist
    const buttons = document.querySelectorAll('.quick-add-btn');
    console.log('Found', buttons.length, 'quick-add-btn elements');

    // Handle quick add button clicks
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.quick-add-btn');
      if (btn && !btn.disabled && !btn.classList.contains('sold-out')) {
        handleQuickAdd(btn);
      }
    });
  }

  /**
   * Handle quick add to cart
   */
  function handleQuickAdd(btn) {
    const variantId = btn.getAttribute('data-variant-id');
    const productId = btn.getAttribute('data-product-id');
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Set loading state
    btn.classList.add('loading');
    btn.disabled = true;

    // Prepare form data
    const formData = {
      id: variantId,
      quantity: 1
    };

    // Add to cart via Shopify Ajax API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    })
    .then(data => {
      // Success!
      btn.classList.remove('loading');
      btn.classList.add('success');
      
      // Update button text temporarily
      const textSpan = btn.querySelector('.quick-add-text');
      const originalText = textSpan.textContent;
      textSpan.textContent = 'Added!';
      
      // Show success icon
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.innerHTML = '<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>';
      }

      // Show toast notification
      showToast('Added to cart!');

      // Trigger theme's cart update event (for cart drawer)
      $('body').trigger('added.ajaxProduct');
      
      // Also trigger generic cart refresh event
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      // Update cart count if element exists
      updateCartCount();

      // Reset button after 2 seconds
      setTimeout(() => {
        btn.classList.remove('success');
        btn.disabled = false;
        textSpan.textContent = originalText;
        
        // Reset icon
        if (svg) {
          svg.innerHTML = '<path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>';
        }
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      
      // Error state
      btn.classList.remove('loading');
      btn.disabled = false;
      
      // Show error toast
      showToast('Error adding to cart. Please try again.', 'error');
    });
  }

  /**
   * Show toast notification
   */
  function showToast(message, type = 'success') {
    let toast = document.getElementById('quick-add-toast');
    
    // Create toast if it doesn't exist
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'quick-add-toast';
      toast.className = 'quick-add-toast';
      toast.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
        </svg>
        <span id="quick-add-toast-text"></span>
      `;
      document.body.appendChild(toast);
    }

    const textSpan = toast.querySelector('#quick-add-toast-text');
    if (textSpan) {
      textSpan.textContent = message;
    }

    // Change color for error
    if (type === 'error') {
      toast.style.background = '#d32f2f';
    } else {
      toast.style.background = 'var(--color-primary, #356859)';
    }

    // Show toast
    toast.classList.add('show');

    // Hide after 3 seconds
    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  }

  /**
   * Update cart count in header
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart bubble visibility (theme specific)
        const cartBubbles = document.querySelectorAll('.cart-link__bubble');
        cartBubbles.forEach(bubble => {
          if (cart.item_count > 0) {
            bubble.classList.add('cart-link__bubble--visible');
          } else {
            bubble.classList.remove('cart-link__bubble--visible');
          }
        });

        // Update any cart count text elements
        const countSelectors = [
          '.cart-count',
          '[data-cart-count]',
          '#CartCount'
        ];

        countSelectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(el => {
            el.textContent = cart.item_count;
          });
        });
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }

  // Expose functions for potential theme integration
  window.QuickAddToCart = {
    showToast: showToast,
    updateCartCount: updateCartCount
  };

})();
